import { apiFetch } from '@/api'
import { LotNumber } from '@/interfaces'

export const fetchAllLotNumbers = async (): Promise<LotNumber> =>
  (await apiFetch('/lotNumbers', { method: 'GET' })).data
